import { clientDataService } from "../config/axios";

export const signUpEndpoint = async (data) =>{
  return await clientDataService({
    url: `/api/sign-up`,
    method: 'POST',
    data: data,
  });
}
